import { CommonModule, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { BadgeComponent } from '../badge/badge.component';

@Component({
  selector: 'app-suggested-result',
  standalone: true,
  imports: [CommonModule, RouterLink, BadgeComponent, NgIf, NgOptimizedImage],
  templateUrl: './suggested-result.component.html',
  styleUrls: ['./suggested-result.component.scss']
})
export class SuggestedResultComponent implements OnInit {
  @Input() type = '';
  @Input() hasFocus = false;
  @Input() result: any;
  @Input() name = '';
  @Output() openAtecoPopupEvt = new EventEmitter();

  routerLink = '';
  profileImg = '';
  subtitle = '';

  imgLogoErrorArray = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public main: AppComponent,
  ) { }

  ngOnInit(): void {
    this.setData();
  }

  setData(): void {
    if (this.result.professionist) {
      this.routerLink = '/consulente-credito-mutui-prestiti-assicurazioni/' + this.result.professionist?.slug;
      this.profileImg = this.result?.professionist?.member?.profile_img;
      this.subtitle = this.result.professionist?.brand?.name;
    } else {
      switch (this.result.type) {
        case 'agent':
          this.routerLink = '/dettaglio-agente/' + this.result?.data?.agent.slug;
          this.profileImg = this.result?.data?.agent?.member?.profile_img;
          this.subtitle = ' • ' + this.result?.data?.agent?.agency?.name;
          break;
        case 'agency':
          this.routerLink = '/dettaglio-agenzia/' + this.result?.data?.slug;
          this.profileImg = this.result?.data?.logo_img;
          this.subtitle = '• ' + this.result?.data?.city;
          break;
      }
    }

  }

  handleClickOnAtecoResult(): void {
    if (this.result.type === 'ateco_company' || this.result.type === 'ateco_company_agent') {
      this.openAtecoPopupEvt.emit();
    } else {
      this.main?.linkBlank(this.routerLink);
    }
  }

  // GESTIONE LOGHI AGENZIA
  handleBrokenLogo(name: string): void {
    this.imgLogoErrorArray.push(name);
  }

  checkBrokenLogo(name: string): boolean {
    return this.imgLogoErrorArray.includes(name);

  }

}
